"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAmountSign = exports.createNewBudgetItems = void 0;
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const createNewBudgetItems = (budget, groupId, dateRange, itemInfo) => {
    var _a;
    let itemsToAdd = (0, immutable_1.List)();
    let startingDate = dateRange.startDate.set({ month: 1, day: 1 });
    const isIncome = itemInfo.coa && categories_1.categoriesSelectors.isIncomeCat(null, itemInfo.coa.id);
    do {
        const newBudgetItem = budget_items_1.budgetItemsTypes.mkBudgetItem({
            clientId: (0, uuid_1.v4)().toUpperCase(),
            budgetId: budget.id,
            startDate: (_a = startingDate.toISODate()) !== null && _a !== void 0 ? _a : undefined,
            amount: (isIncome ? Math.abs(itemInfo.amount) : -Math.abs(itemInfo.amount)),
            coa: itemInfo.coa && chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount(itemInfo.coa),
            groupId,
            name: itemInfo.name || chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, itemInfo.coa),
            type: itemInfo.budgetItemType || 'COA',
        });
        itemsToAdd = itemsToAdd.push(newBudgetItem);
        startingDate = startingDate.plus({ months: 1 });
    } while (startingDate.month !== 1);
    return itemsToAdd;
};
exports.createNewBudgetItems = createNewBudgetItems;
const setAmountSign = (amt, coa) => {
    // for the budget item, we flip the sign for expense cats when this amount was provided
    // from the category review card
    if (coa) {
        return categories_1.categoriesSelectors.isIncomeCat(null, coa.id) ? amt : -amt;
    }
    return amt;
};
exports.setAmountSign = setAmountSign;
